<template>
  <AlertDialogRoot v-slot="slotProps" data-slot="alert-dialog" v-bind="forwarded">
    <slot v-bind="slotProps" />
  </AlertDialogRoot>
</template>

<script setup>
import { AlertDialogRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps({
  open: { default: undefined, type: Boolean, required: false },
  defaultOpen: { default: undefined, type: Boolean, required: false },
  unmountOnHide: { default: undefined, type: Boolean, required: false },
});
const emits = defineEmits(['update:open']);

const forwarded = useForwardPropsEmits(props, emits);
</script>
